<style lang="scss" scoped>
@import '../../../sass/variables';

.report {
  .card {
    padding: 20px;
    border-radius: 15px 0px 0px 15px;

    .card-report-header {
      .btn-group {
        .btn-report-header {
          color: $gray-light;
          font-size: 0.75rem;
          font-weight: 500;
          line-height: 1.5em;
          text-decoration: underline;
          letter-spacing: -0.18px;
          padding: 0;

          &.active {
            color: $purple;
            font-weight: 700;
          }

          img {
            height: 15px;
            margin-right: 5px;
          }
        }
      }
    }

    .card-report-body {
      .chart {
        min-height: 544px;
      }
    }
  }

  .report-table {
    width: 253px;
    height: 610px;
    border-radius: 0px 15px 15px 0px;
    background-color: $white;
    box-shadow: 0px 8px 24px 0px #D1D1D1;
    padding: 0;
  }

  ::v-deep .chart {
    .apexcharts-svg {
      height: 600px !important;
    }

    .apexcharts-canvas {
      right: 15px;
    }
  }
}

.export-button {
  color: #71767D;
  font-family: 'Montserrat';
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
}

.export-button:hover {
  background-color: #5F33FF;
  color: #FFFFFF;
}

#chart-container {
  width: 1082px;
  height: 633px;
  background: white;
  padding: 16px;

  #report-chart {
    height: 633px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: space-around;
    background: white;
  }

  #pie-and-chart-legend-container {
    background: white;
    height: 316px;
  }

  #pie-col {
    #image-from-chart-pie {
      height: 316px;
    }
  }

  #chart-legend-title {
    font-size: 10px;
    font-weight: 700;
    line-height: 130%;

    li {
      font-weight: 500;
    }
  }
}

#report-table-export {
  background-color: #f8f8f8;
}

#chart-legend-list {
  padding-left: 0;
}

.page-subtitle {
  margin-bottom: 0px;
  font-family: Montserrat;
  font-size: 28px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%
}

.small-text {
  display: block;
  margin-top: 0;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}

</style>

<template>
  <section class="report" id="report-show-container">
    <div class="row">
      <div class="col-12 pl-30px d-flex align-items-center">
        <h2 class="page-subtitle">
          {{ __(name) }}<span class="small-text"> {{ __(description) }}</span>
        </h2>
        <div class="ml-auto">
          <InputDaterange name="range" theme="modern" :placeholder="__('Estou vendo: últimos 15 dias')" v-model="range"
            preset="report" position="left" />
        </div>
        <div>
          <button v-on:click="openExportModal" class="btn btn-bulldesk ml-3 export-button">
            <span>{{__('Exportar Relatório')}}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="mt-3 mb-30px" v-if="loading === false">
      <div class="row">
        <div class="col-12 d-flex">
          <div class="card col">
            <div class="card-report-header">
              <div class="row">
                <div class="col-6">
                  <BButtonGroup>
                    <button class="btn btn-secundary btn-report-header mr-4" type="button"
                      :class="{ active: timeperiod == 'day' }" @click="setTimeperiod('day')" v-show="isTimeperiod">
                      {{ __('Diário') }}
                    </button>
                    <button class="btn btn-secundary btn-report-header mr-4" type="button"
                      :class="{ active: timeperiod == 'month' }" @click="setTimeperiod('month')" v-show="isTimeperiod">
                      {{ __('Mensal') }}
                    </button>
                    <button class="btn btn-secundary btn-report-header mr-4" type="button"
                      :class="{ active: timeperiod == 'year' }" @click="setTimeperiod('year')" v-show="isTimeperiod">
                      {{ __('Anual') }}
                    </button>
                  </BButtonGroup>
                </div>
                <div class="col-6 d-flex">
                  <BButtonGroup class="ml-auto" v-show="hasTypes()">
                    <button class="btn btn-secundary btn-report-header ml-4" type="button"
                      :class="{ active: current === type }" @click="setType(current)" v-for="current in types"
                      v-if="current === 'bar' || current === 'pie'">
                      <img :src="typeIcon(current + '-active')" v-if="type === current"><img :src="typeIcon(current)"
                        v-else><span>{{ __(getTypeName(current)) }}</span>
                    </button>
                  </BButtonGroup>
                </div>
              </div>
            </div>
            <div class="card-report-body mt-2">
              <div class="chart">
                <ReportChart
                  :key="type"
                  :source="source" height="500"
                  :type="type"
                  :stacked="stacked"
                  :timeseries="timeseries"
                  :range="range"
                  :alert="true"
                  :timeperiod="timeperiod"
                  :id="'browserChart'" />
              </div>
            </div>
          </div>
          <div class="report-table col-2">
            <ReportTable :source="source" :timeseries="timeseries" :range="range" :alert="true"
              :timeperiod="timeperiod" />
          </div>
        </div>
      </div>
    </div>
    <div
      style="visibility: hidden; opacity: 0;"
      class="card-report-body mt-2 p-0 d-flex" ref="chartContainer" id="chart-container">
      <div class="chart col-9" id="report-chart" ref="reportChart">
        <picture id="row-bar-chart"></picture>
        <div class="d-flex" id="pie-and-chart-legend-container">
          <div class="col-4" id="chart-legend-col">
            <h3 id="chart-legend-title">LEGENDA</h3>
            <ul id="chart-legend-list">
            </ul>
          </div>
          <div class="col-6" id="pie-col">
            <picture id="row-pie-chart"></picture>
          </div>
        </div>
      </div>
      <div class="col-3" id="report-table-export">
        <ExportSummary
          :source="source"
          :timeseries="timeseries"
          :range="range"
          :alert="true"
          :timeperiod="timeperiod"
          :deselectedData="deselectedData"
        />
      </div>
    </div>
    <ExportReportModal title="Exportar relatório"
      :source="source"
      :range="range"
      :timeperiod="timeperiod"
      :timeseries="timeseries"
      :types="types"
      @send-deselecteds = "handleDeselectedData"
    />
  </section>
</template>

<script>
import { BButtonGroup, BModal } from 'bootstrap-vue';
import html2canvas from 'html2canvas';
import dayjs from '../../core/dayjs';

const Strings = require('../../services/strings.js');

export default {
  components: {
    BButtonGroup,
    BModal
  },

  props: ['source', 'csrf', 'name', 'description'],

  mounted() {
    this.getOptions();
    Bus.$on('send-deselecteds', this.handleDeselectedData);
    Bus.$on('createCanvas', (callback) => this.createCanvas(callback));
  },

  beforeDestroy() {
    Bus.$off('send-deselecteds', this.handleDeselectedData);
    Bus.$off('createCanvas');
  },

  data() {
    return {
      type: 'bar',
      types: [
        'pie',
        'bar',
      ],
      range: null,
      stacked: false,
      timeseries: true,
      timeperiod: 'day',
      loading: true,
      elementId: Strings.generateHash(),
      deselectedData: [],
      defaults: {
        chart: {
          height: 400,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: true,
          },
        },
        legend: {
          show: this.legend || true,
          position: 'top',
          horizontalAlign: 'right',
          fontFamily: 'Montserrat',
          fontSize: '10px',
          labels: {
            colors: ['#71767D']
          },
          fontWeight: 316,
        },
        grid: {
          show: true,
          borderColor: '#E0DBE8',
          strokeDashArray: 2,
          position: 'back',
          xaxis: {
            lines: {
              show: false,
            },
          },
          yaxis: {
            lines: {
              show: true,
            },
            labels: {
              show: true,
              style: {
                fontSize: '10px',
                fontWeight: 400,
                colors: ['#ff00ff'],
                lineHeight: '12px'
              }
            }
          },
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
        yaxis: {
          labels: {
            show: true,
            style: {
              fontSize: '10px',
              fontWeight: 400,
              colors: ['#71767D'],
              lineHeight: '12px'
            }
          }
        },
        xaxis: {
          labels: {
            show: true,
            style: {
              fontSize: '10px',
              fontWeight: 400,
              colors: ['#242424'],
              lineHeight: '12px'
            }
          }
        }
      },
    };
  },

  computed: {
    isTimeperiod() {
      return this.type !== 'pie' && this.timeseries;
    },
  },

  methods: {
    exportReport() {
      this.$http.post(`/export/${this.source}/csv`, {
        range: this.range,
        filters: []
      }).then(response => {
        console.log(response.data);
      })
    },

    getOptions() {
      this.$http.get(`/report/source/${this.source}/options`)
        .then((response) => {
          const options = response.data;

          if (typeof options.chart.type !== 'undefined') {
            this.type = options.chart.type;
          }

          if (typeof options.chart.types !== 'undefined') {
            this.types = options.chart.types;
          }

          if (typeof options.chart.stacked !== 'undefined') {
            this.stacked = options.chart.stacked;
          }

          if (typeof options.chart.timeseries !== 'undefined') {
            this.timeseries = options.chart.timeseries;
          }

          this.loading = false;
        });
    },

    openExportModal() {
      Bus.$emit('openExportModal');
    },

    setTimeperiod(timeperiod) {
      this.timeperiod = timeperiod;

      // Don't stack when there's no timeperiod/timeseries
      if (timeperiod === false) {
        this.stacked = false;
        this.timeseries = false;
      } else {
        this.timeseries = true;
      }
    },

    isType(type) {
      return this.types.indexOf(type) > -1 && this.type === type;
    },

    setType(type) {
      if (type !== 'bar') {
        this.stacked = false;
      } else {
        this.stacked = true;
      }

      this.type = type;
    },

    hasTypes() {
      return this.types.length > 1;
    },

    typeIcon(type) {
      return `/build/icons/report/${type}.svg`;
    },

    getTypeName(type) {
      const names = {
        pie: 'Pizza',
        bar: 'Barra',
        area: 'Área',
        line: 'Linha',
        funnel: 'Funil',
        total: 'Total',
        avg: 'Média',
      };

      return names[type];
    },

    getChartOptions(fetched, type) {
      const options = this.defaults;
      options.id = this.id;
      options.chart.type = type;
      options.chart.stacked = this.stacked;

      if (this.height) {
        options.chart.height = this.height;
      }

      if (this.title) {
        options.title = {
          text: this.title,
          style: {
            color: '#71767D'
          }
        };
      }

      options.plotOptions = {};

      let ticks = fetched.data.categories.length;

      if (!this.stacked) {
        ticks *= 3;
      }

      if (this.type === 'bar') {
        let columnWidth = 1 / ticks * 100;

        if (columnWidth < 1.5) {
          columnWidth = 15;
        }

        if (columnWidth > 4 && columnWidth <= 10) {
          columnWidth = 18;
        }

        if (columnWidth > 10) {
          columnWidth = 15;
        }

        options.plotOptions.bar = {
          horizontal: false,
          // distributed: true,
          // endingShape: 'rounded',
          columnWidth: `${columnWidth}%`,
        };
      }

      options.xaxis = {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        tickPlacement: 'between',
      };

      options.dataLabels = {
        enabled: false,
      };

      const dates = this.getDates(fetched.data.categories);

      const sortedDates = this.getSortedDates(dates);

      if (this.timeseries) {
        options.xaxis = {
          ...options.xaxis,
          // categories: fetched.data.categories.map((category) => category + ' GMT'),
          categories: sortedDates.map((item) => dayjs(item).format(this.format)),
        };
        // options.xaxis.labels = {format: this.format};
      } else {
        options.xaxis = {
          ...options.xaxis,
          // type => 'category',
          categories: fetched.data.categories,
          // labels: {}
        };
      }

      if (this.axis === false) {
        options.xaxis.labels.show = false;
      }

      if (ticks > 25) {
        options.xaxis.labels = options.xaxis.labels || {};
        options.xaxis.labels.rotate = -45;
        options.xaxis.labels.rotateAlways = true;
        options.xaxis.labels.hideOverlappingLabels = false;
      }

      const order = this.getOrder(dates, sortedDates);

      options.labels = [];
      options.colors = fetched.data.colors;
      options.series = !this.timeseries
        ? fetched.data.series
        : fetched.data.series.map((item) => {
          const data = order.map((value) => item.data[value]);

          return { ...item, data };
        });

      if (this.legend === false) {
        options.legend = { show: false };
      }

      if (['pie', 'donut'].indexOf(options.chart.type) !== -1) {
        options.stroke = {
          width: 0,
        };
        options.tooltip = {
          style: {
            fontSize: '12px',
            fontFamily: undefined,
          },
          custom: ({
            series, seriesIndex, dataPointIndex, w,
          }) => {
            let total = 0;

            for (const x of series) {
              total += x;
            }

            const selected = series[seriesIndex];

            return `${w.config.labels[seriesIndex]
              }: <span class="value">${selected}</span>`
              + `<span class="percent">${(selected / total * 100).toFixed(0)}%</span>`;
          },
        };
        options.series = fetched.data.labeled.series;
        options.labels = fetched.data.labeled.labels;
      } else {
        options.stroke = {};
      }
      return options;
    },

    async createAnImageFromChart(fetched, customOptions, types) {
      types.forEach((type, i) => {
        const options = this.getChartOptions(fetched, type);
        options.chart = {
          ...options.chart,
          height: '316',
          width: type === 'pie' ? '316' : '100%',
          animations: { enabled: false } ,
          type: type
        };
        options.dataLabels = {
          style: {
            fontSize: '16px',
          },
        };
        options.legend = {
          style: {
            fontSize: '16px',
          },
        };
        options.grid.yaxis.labels.style = {
          ...options.grid.yaxis.labels.style,
          fontSize: '16px',
        };

        if (document.querySelector('#export-chart')) {
          document.querySelector('#export-chart').remove();
        }

        const chartDiv = document.createElement('div');
        chartDiv.setAttribute('id', 'export-chart');
        chartDiv.setAttribute('ref', 'exportChart');
        chartDiv.style.visibility = 'hidden';

        document.querySelector('#report-show-container').appendChild(chartDiv);

        const apexChartToExport = new ApexCharts(document.querySelector('#export-chart'), { ...options, ...customOptions, legend: { show: false } });

        apexChartToExport.render().then(() => {
          setTimeout(() => {
            apexChartToExport.dataURI().then(({ imgURI }) => {
              apexChartToExport.updateOptions(options, true).then(() => {
                if (document.querySelector(`#image-from-chart-${type}`)) {
                  document.querySelector(`#image-from-chart-${type}`).remove();
                }

                const img = document.createElement('img');
                img.src = imgURI;
                img.setAttribute('id', `image-from-chart-${type}`);
                img.setAttribute('class', 'img-fluid');

                const typeWithCapitalFirstLetter = type.charAt(0).toUpperCase() + type.slice(1);
                img.setAttribute('ref', `imageFromChart${typeWithCapitalFirstLetter}`);

                const divRowId = `row-${type}-chart`;
                document.querySelector(`#${divRowId}`).appendChild(img);
              });
            });
          }, 1000);
        });
      });

      document.querySelector('#export-chart').remove();

      const chartLegendListChildNodes = document.querySelector('#chart-legend-list').childNodes;
      while (chartLegendListChildNodes.length > 0) {
        document.querySelector('#chart-legend-list').removeChild(chartLegendListChildNodes[0]);
      }

      fetched.data.labeled.labels.forEach((label, i) => {
        const legendItemWrapper = document.createElement('div');
        legendItemWrapper.style.display = 'flex';
        legendItemWrapper.style.alignItems = 'center';
        legendItemWrapper.style.gap = '6px';
        legendItemWrapper.setAttribute('id', `container-${label}-${i}`);
        document.querySelector('#chart-legend-list').appendChild(legendItemWrapper);

        const legendDot = document.createElement('span');
        const legendDotClass = {
          display: 'block',
          height: '10px',
          width: '10px',
          backgroundColor: fetched.data.colors[i],
          borderRadius: '50%',
        };
        Object.assign(legendDot.style, legendDotClass);
        legendItemWrapper.setAttribute('id', `dot-label-${label}-${i}`);
        legendItemWrapper.appendChild(legendDot);

        const legendItemText = document.createElement('li');
        legendItemText.innerText = label;
        legendItemText.style.listStyleType = 'none';
        legendItemText.setAttribute('id', `label-${label}-${i}`);
        legendItemText.setAttribute('ref', `label${label}${i}`);
        legendItemWrapper.appendChild(legendItemText);
      });
    },

    handleDeselectedData(deselectedData) {
      console.log("Received deselectedData in Show: ", deselectedData);

      this.deselectedData = deselectedData
    },

    async createCanvas(params) {
      console.log(this.deselectedData);

      this.createAnImageFromChart(params.fetched, {
        dataLabels: {
          position: 'top',
          enable: true
        },
        id: 'reportApexChartInstance'
      }, ['bar', 'pie']).then(() => {
        setTimeout(() => {
          document.querySelector('#chart-container').style.visibility = 'visible';
          html2canvas(document.querySelector('#chart-container')).then(canvas => {
            // document.body.appendChild(canvas);
            const img = canvas.toDataURL('image/jpeg');

            // document.querySelector('#chart-container').style.visibility = 'hidden'

            // var newTab = window.open();
            // newTab.document.body.innerHTML = `<img src=${img} width="1082" height="633">`;

            return params.callback(img);
          });
        }, 1500);
      });
    },

    getOrder(dates, sortedDates) {
      return sortedDates.map((item, index) => dates.findIndex((date) => date.getTime() === item.getTime()));
    },

    getDates(dates) {
      return dates.map((item) => new Date(dayjs(item).format('YYYY/MM/DD')));
    },

    getSortedDates(dates) {
      // @todo move to own fn file
      return [...dates].sort((left, right) => {
        const diff = left.getTime() - right.getTime();

        if (diff < 0) {
          return -1;
        }

        if (diff > 0) {
          return 1;
        }

        return diff;
      });
    },

  },
};
</script>
